import { render } from "./TheInstanceDropdown.vue?vue&type=template&id=18283372"
import script from "./TheInstanceDropdown.vue?vue&type=script&lang=js"
export * from "./TheInstanceDropdown.vue?vue&type=script&lang=js"
script.render = render

export default script